import * as React from 'react';
import { Button } from '../button/button';
import styles from './placeholder.module.css';
export const Placeholder = ({ src, title, subTitle, dataTestId, image, buttonText, onClick, buttonDataTestId, }) => (React.createElement("div", { className: styles.Placeholder, "data-test-id": dataTestId },
    src && React.createElement("img", { src: src, className: styles.Image }),
    image && React.createElement("div", { className: styles.SVGImage }, image),
    title && React.createElement("h2", { className: styles.Title }, title),
    subTitle && React.createElement("h3", { className: styles.Subtitle }, subTitle),
    buttonText && (React.createElement(Button, { onClick: onClick, classes: styles.Button, dataTestId: buttonDataTestId }, buttonText))));
